module.exports = __webpack_public_path__ + "img/CSAT3.e7105b19.svg";